import React, { useEffect, useState } from 'react';
import { VPN_GEOIP_URL } from '../config';
import { checkoutGeoipUi } from '../constants/checkoutV2Locales';

function pickLocalizedName(names) {
  if (!names || typeof names !== 'object') return null;
  const lang = (typeof navigator !== 'undefined' && navigator.language
    ? navigator.language.split('-')[0]
    : 'en') || 'en';
  return names[lang] || names.en || Object.values(names).find(Boolean) || null;
}

export function CheckoutGeoipInfo({ locale = 'en' } = {}) {
  const [loading, setLoading] = useState(true);
  const [payload, setPayload] = useState(null);
  const geo = checkoutGeoipUi(locale);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(VPN_GEOIP_URL, { method: 'GET' });
        const text = await r.text();
        let data = {};
        try {
          data = text ? JSON.parse(text) : {};
        } catch {
          return;
        }
        const body = data.body ?? data;
        if (!cancelled && r.ok && body && !body.error) {
          setPayload(body);
        }
      } catch {
        /* ignore — checkout works without geo */
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const ip =
    payload?.ip || payload?.geoip?.traits?.ip_address || null;
  const city = pickLocalizedName(payload?.geoip?.city?.names);
  const subdivisions = Array.isArray(payload?.geoip?.subdivisions)
    ? payload.geoip.subdivisions
        .map((s) => pickLocalizedName(s?.names) || s?.iso_code)
        .filter(Boolean)
    : [];

  if (loading) {
    return (
      <div className="checkout-geoip-info" aria-live="polite">
        {geo.loading}
      </div>
    );
  }

  const locationParts = [city, ...subdivisions].filter(Boolean);
  const locationSegment =
    locationParts.length > 0
      ? `${geo.locationPrefix}${locationParts.join(', ')}`
      : null;

  const segments = [];
  if (ip) {
    segments.push(`${geo.ipPrefix}${ip}`);
  }
  if (locationSegment) segments.push(locationSegment);
  const line = segments.join(' · ');

  if (!line) {
    return null;
  }

  return (
    <div className="checkout-geoip-info" aria-live="polite">
      {line}
    </div>
  );
}
